
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.786 24a7 7 0 00-6.733 5.04 9.749 9.749 0 00-7.7 9.36v1.2a3.607 3.607 0 01-7.214 0v-8.64a14.683 14.683 0 0012.024-10.8L33.331 12a10.7 10.7 0 00-2.164-8.4 10.62 10.62 0 00-7.7-3.6 2.27 2.27 0 00-2.4 2.4 2.27 2.27 0 002.4 2.4 5.141 5.141 0 014.093 1.92 5.71 5.71 0 011.2 4.32l-2.164 7.92a10.253 10.253 0 01-19.719 0l-2.164-7.92a5.71 5.71 0 011.2-4.32 5.51 5.51 0 014.091-1.92 2.27 2.27 0 002.4-2.4 2.27 2.27 0 00-2.4-2.4 10.62 10.62 0 00-7.7 3.6 10.779 10.779 0 00-2.16 8.64l2.164 7.92a14.683 14.683 0 0012.024 10.8v8.64a8.417 8.417 0 0016.834 0v-1.2a4.741 4.741 0 012.886-4.32 7.152 7.152 0 006.733 4.32 7.079 7.079 0 007.214-7.2 7.228 7.228 0 00-7.213-7.2zm0 9.6a2.4 2.4 0 112.4-2.4 2.408 2.408 0 01-2.4 2.4z","fill":"#fff"}})])
          )
        }
      }
    